/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".api_button2[_ngcontent-%COMP%]:disabled{cursor:progress}"];
export { styles as styles };
